
import { Alert } from '../../../models/const/alert.model';

export class CreateNewSettingsAlert {
    static readonly type = '[SettingsAlerts] CreateNewSettingsAlert';
    constructor(public message: string) {}
}

export class DismissSettingsAlert {
    static readonly type = '[SettingsAlerts] DismissSettingsAlert';
    constructor(public alert: Alert) {}
}

export class ClearSettingsAlertsStore {
    static readonly type = '[SettingsAlerts] ClearSettingsAlertsStore';
    constructor() {}
}
